export default "__VITE_ASSET__J2ByDcab__"